const getIsWatchTillEndBanner = (selectedBite) => {
  return selectedBite?.bite_sections.some((section) => section.type === 'question');
};

export default getIsWatchTillEndBanner;
